import { render, staticRenderFns } from "./BizEndorseModal.vue?vue&type=template&id=0b9bc0c0&"
import script from "./BizEndorseModal.vue?vue&type=script&lang=js&"
export * from "./BizEndorseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports